module.exports = "<img class=\"picwidth\" src=\"{{params.value}}\" (click)=\"fnShowZoomProduct(params.data.skuid)\" >"